import { render, staticRenderFns } from "./productos.vue?vue&type=template&id=2e1e8998&scoped=true"
import script from "./productos.vue?vue&type=script&lang=js"
export * from "./productos.vue?vue&type=script&lang=js"
import style0 from "./productos.vue?vue&type=style&index=0&id=2e1e8998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1e8998",
  null
  
)

export default component.exports